import { createContext } from 'react';

// Desktop dialogs have their own available space, independent of the window.
export default createContext(null);
